export var UMENGEventId = {
  anniversary_activity_click: 'anniversary_activity_click',
  // 周年庆活动
  home_info_click: 'home_info_click',
  // 首页-消息icon
  home_drawer_click: 'home_drawer_click',
  // 首页-抽屉icon
  banner_click: 'banner_click',
  // 首页-点击任意banner
  home_brand_click: 'home_brand_click',
  // 首页-品牌馆icon
  home_recommend_click: 'home_recommend_click',
  // 首页-点击为你推荐内的NFR
  home_collector_click: 'home_collector_click',
  // 首页-点击首页榜单内的收藏者
  home_all_click: 'home_all_click',
  // 首页-点击首页收藏者“查看全部”
  market_click: 'market_click',
  // 首页-点击市场Tab
  search_click: 'search_click',
  // 首页-点击搜索Tab
  exhibition_click: 'exhibition_click',
  // 首页-点击品牌馆Tab
  user_click: 'user_click',
  // 首页-点击我的Tab
  market_new_click: 'market_new_click',
  // 大市场-点击“最新”
  market_price_click: 'market_price_click',
  // 大市场-点击“价格”
  market_transaction_click: 'market_transaction_click',
  // 大市场-点击“转售”
  market_filter_click: 'market_filter_click',
  // 大市场-点击“筛选”
  market_nfr_click: 'market_nfr_click',
  // 大市场-点击任市场内意NFR
  search_input_click: 'search_input_click',
  // 搜索-点击搜索框
  search_history_click: 'search_history_click',
  // 搜索-点击任意“历史记录”
  search_collection_click: 'search_collection_click',
  // 2.6.4被剔除 搜索-点击搜索tab下“我的收藏”中任意品牌馆
  search_fields_click: 'search_fields_click',
  // 2.6.4被剔除 搜索-点击领域中任意领域
  search_subject_click: 'search_subject_click',
  // 2.6.4被剔除 搜索-点击任意趋势内的专题
  exhibition_recruit_click: 'exhibition_recruit_click',
  // 品牌馆-点击品牌馆页“招募令”
  exhibition_collection_click: 'exhibition_collection_click',
  // 品牌馆-点击品牌馆页我的收藏模块内任意品牌馆
  exhibition_brand_click: 'exhibition_brand_click',
  // 品牌馆-点击品牌馆列表中任意品牌馆
  user_setting_click: 'user_setting_click',
  // 我的-点击“设置”
  user_helpcenter_click: 'user_helpcenter_click',
  // 我的-点击“帮助中心”
  user_official_account_click: 'user_official_account_click',
  // 我的-点击“关注公众号”
  user_download_click: 'user_download_click',
  // 我的-点击“下载APP”
  user_personalhome_click: 'user_personalhome_click',
  // 我的-点击“个人主页”
  user_userinfo_click: 'user_userinfo_click',
  // 我的-点击“账户资料”
  user_assets_click: 'user_assets_click',
  // 我的-点击“资产”
  user_wallet_click: 'user_wallet_click',
  // 我的-点击“钱包”
  user_personal_gallery_click: 'user_personal_gallery_click',
  // 我的-点击“我的展厅”
  user_medal_click: 'user_medal_click',
  // 我的-点击“荣誉勋章”
  user_task_click: 'user_task_click',
  // 我的-点击“有奖任务”
  user_invite_click: 'user_invite_click',
  // 我的-点击“邀请好友”
  user_reservation_click: 'user_reservation_click',
  // 我的-点击“我的预约”
  user_follow_click: 'user_follow_click',
  // 我的-点击“我的关注”
  user_convert_record_click: 'user_convert_record_click',
  // 我的-点击“兑换记录”
  user_purchase_click: 'user_purchase_click',
  // 我的-点击“我的购买”
  user_customer_services_click: 'user_customer_services_click',
  // 我的-点击“联系客服”
  exhibition_detail_share_click: 'exhibition_detail_share_click',
  // 品牌馆详情-点击品牌馆详情页“分享”按钮
  exhibition_detail_collection_click: 'exhibition_detail_collection_click',
  // 品牌馆详情-点击品牌馆详情页“收藏”按钮
  exhibition_detail_roadmap_click: 'exhibition_detail_roadmap_click',
  // 品牌馆详情-点击品牌馆详情页“roadmap”
  exhibition_detail_dodo_click: 'exhibition_detail_dodo_click',
  // 品牌馆详情-点击品牌馆详情页“dodo”按钮
  exhibition_detail_wb_click: 'exhibition_detail_wb_click',
  // 品牌馆详情-点击品牌馆详情页“微博”按钮
  exhibition_detail_cs_click: 'exhibition_detail_cs_click',
  // 品牌馆详情-点击品牌馆详情页“联系我们”按钮
  exhibition_detail_allsubject_click: 'exhibition_detail_allsubject_click',
  // 品牌馆详情-点击品牌馆详情页“全部专题”按钮
  exhibition_detail_market_click: 'exhibition_detail_market_click',
  // 品牌馆详情-点击品牌馆详情页“品牌馆市场”按钮
  exhibition_detail_task_click: 'exhibition_detail_task_click',
  // 品牌馆详情-点击品牌馆详情页“有奖任务”按钮
  exhibition_detail_subject_click: 'exhibition_detail_subject_click',
  // 品牌馆详情-点击品牌馆详情页“专题详情”按钮
  subject_share_click: 'subject_share_click',
  // 专题详情-点击专题详情页“分享”按钮
  subject_publisher_click: 'subject_publisher_click',
  // 专题详情-点击专题详情页“发售方”
  subject_mode_click: 'subject_mode_click',
  // 专题详情-点击专题详情页“发售模式”
  subject_auth_click: 'subject_auth_click',
  // 专题详情-点击专题详情页“作者与NFRs”
  subject_subscribe_click: 'subject_subscribe_click',
  // 专题详情-点击专题详情页“订阅”按钮
  subject_purchase_click: 'subject_purchase_click',
  // 专题详情-点击专题详情页“购买”按钮
  nfr_detail_share_click: 'nfr_detail_share_click',
  // NFR详情-点击NFR详情页“分享”按钮
  nfr_detail_preview_click: 'nfr_detail_preview_click',
  // NFR详情-点击NFR详情页“预览”区域
  nfr_detail_subject_click: 'nfr_detail_subject_click',
  // NFR详情-点击NFR详情页“专题”
  nfr_detail_info_click: 'nfr_detail_info_click',
  // NFR详情-点击NFR详情页“NFR信息”
  nfr_detail_rights_click: 'nfr_detail_rights_click',
  // NFR详情-点击NFR详情页“权利”
  nfr_detail_copyright_click: 'nfr_detail_copyright_click',
  // NFR详情-点击NFR详情页“版权金”
  nfr_detail_mode_click: 'nfr_detail_mode_click',
  // NFR详情-点击NFR详情页“交易模式”
  nfr_detail_collect_click: 'nfr_detail_collect_click',
  // NFR详情-点击NFR详情页“收藏”
  nfr_detail_purchase_click: 'nfr_detail_purchase_click',
  // 点击NFR详情页“购买”
  youth_activities_index_click: 'youth_activities_index_click',
  // 活动主页】的UV、PV
  youth_activities_weibo_click: 'youth_activities_weibo_click',
  // 【通过微博端进入活动主页】的UV、PV
  youth_activities_dodo_click: 'youth_activities_dodo_click',
  // 【通过DODO端进入活动主页】的UV、PV
  youth_activities_xiaohongshu_click: 'youth_activities_xiaohongshu_click',
  // 【通过小红书端进入活动主页】的UV、PV
  youth_activities_find_result_click: 'youth_activities_find_result_click',
  // 【输入昵称页点击查看结果按钮】的次数
  youth_activities_login_click: 'youth_activities_login_click',
  // 【登录】的UV、PV
  youth_activities_register_click: 'youth_activities_register_click',
  // 【注册】的UV、PV
  youth_activities_save_poster_click: 'youth_activities_save_poster_click',
  // 【长按保存海报按钮】的次数
  banner_crowd_funding_click: 'banner_crowd_funding_click',
  // 首页-点击banner进入商城UV、PV
  crowd_funding_mall_center_click: 'crowd_funding_mall_center_click',
  // 众筹商城-点击进入商城中心页UV、PV
  copyright_collect_click: 'copyright_collect_click',
  // 我的-点击进入版权品征集页UV、PV
  crowd_funding_cup_click: 'crowd_funding_cup_click',
  // 从商城进入卡珊保温杯众筹页的UV、PV
  crowd_funding_cup_support_click: 'crowd_funding_cup_support_click',
  // 卡珊保温杯点击立即支持的UV、PV
  crowd_funding_cup_share_click: 'crowd_funding_cup_share_click',
  // 卡珊保温杯众筹页分享按钮的UV、PV
  crowd_funding_bag_click: 'crowd_funding_bag_click',
  // 从商城进入当代青年全能包众筹页的UV、PV
  crowd_funding_bag_support_click: 'crowd_funding_bag_support_click',
  // 当代青年全能包点击立即支持的UV、PV
  crowd_funding_bag_share_click: 'crowd_funding_bag_share_click',
  // 当代青年全能包点击分享按钮的UV、PV
  crowd_funding_power_bank_click: 'crowd_funding_power_bank_click',
  // 从商城进入电玩少女充电宝众筹页的UV、PV
  crowd_funding_power_bank_support_click: 'crowd_funding_power_bank_support_click',
  // 电玩少女充电宝点击立即支持的UV、PV
  crowd_funding_power_bank_share_click: 'crowd_funding_power_bank_share_click',
  // 电玩少女充电宝分享按钮的UV、PV
  mini_game_buy_nfr_click: 'mini_game_buy_nfr_click',
  // 【优了个优】购买藏品获得绝处逢生技能产生交易情况数据UV、PV
  party_planet_click: 'party_planet_click',
  // 发现-点击进入派对星球UV、PV
  party_planet_share_click: 'party_planet_share_click',
  // 派对星球-点击详情页“分享”按钮
  page_home: 'page_home',
  // 进入首页
  home_banner_click: 'home_banner_click',
  // 点击任意banner
  home_entry_click: 'home_entry_click',
  // 快捷icon
  home_announcement_all_click: 'home_announcement_all_click',
  // 点击查看所有公告
  home_trend_item_click: 'home_trend_item_click',
  // 点击列表中的内容
  home_sale_item_click: 'home_sale_item_click',
  // 点击列表中的内容
  home_calendar_item_click: 'home_calendar_item_click',
  // 点击列表中的内容
  page_energy: 'page_energy',
  // 进入能量中心页面
  page_application_list: 'page_application_list',
  // 进入应用列表页面
  invitation_event_page: 'invitation_event_page',
  // 进入邀请有礼活动页面
  invitation_event_copy: 'invitation_event_copy',
  // 邀请活动复制链接
  invitation_event_poster: 'invitation_event_poster',
  // 邀请活动分享海报
  newcomer_zone_page: 'newcomer_zone_page',
  // 进入新人专区页面
  nationalDay_page: 'nationalDay_page',
  // 进入国庆活动页面
  nationalDay_event_share: 'nationalDay_event_share',
  // 国庆活动分享按钮
  nationalDay_event_rules: 'nationalDay_event_rules',
  // 国庆活动规则按钮
  nationalDay_event_airdrop: 'nationalDay_event_airdrop',
  // 国庆活动去登录按钮
  nationalDay_event_market: 'nationalDay_event_market',
  // 国庆活动去交易按钮
  nationalDay_event_destroy: 'nationalDay_event_destroy',
  // 国庆活动去熔炼按钮
  nationalDay_event_energy: 'nationalDay_event_energy',
  // 国庆活动去兑换按钮
  nationalDay_event_planet: 'nationalDay_event_planet',
  // 国庆活动去Web3应用中心
  nationalDay_event_activity: 'nationalDay_event_activity',
  // 国庆活动banner跳转
  short_message_enter: 'short_message_enter' // 携带source=msg进入首页
};